import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { AuthProvider } from 'react-oidc-context';
import oidcConfig, { awsConfig } from './aws-config.js';
import { Amplify } from 'aws-amplify';
import ClarityUserProvider from './components/ClarityUserProvider.jsx';
import { BrowserRouter } from 'react-router-dom';
import posthog from 'posthog-js'

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
})

// posthog-js's npm/ESM import doesn't auto-attach to window like the CDN
// snippet does. OnboardingChecklist.jsx and AppTour.jsx both read
// window.posthog directly, so make it available here.
window.posthog = posthog;

// Reports uncaught JS errors and unhandled promise rejections to PostHog as
// $exception events (tied to the identified person), so error visibility
// doesn't depend on a user filing a support ticket.
posthog.startExceptionAutocapture();

// Configure Amplify with the correct endpoint and authentication
if (process.env.NODE_ENV === 'development') {
  console.log('AWS Config loaded');
}
Amplify.configure(awsConfig);

const providerProps = {
  ...oidcConfig,
  autoSignIn: false,
  automaticSilentRenew: false,
  onSigninCallback: (user) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[OIDC] onSigninCallback', !!user);
    }
    window.history.replaceState({}, document.title, window.location.pathname);
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider {...providerProps}>
        <ClarityUserProvider>
          <App />
        </ClarityUserProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
